
function FormFieldIcon({label, children, classes='', target, iconClass='', icon=''}) {
  return (
    <div className="field is-horizontal ">
      <div className="field-label is-normal">
        {label && <label className="label" htmlFor={target}>{label}</label>}
      </div>
      <div className="field-body">
        <div className={`field ${classes}`}>
          <div className='control has-icons-right'>
            { children }
            <span className={`icon is-small is-right ${iconClass}`}>
              <i className={`fas ${icon}`}/>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormFieldIcon;
